import React from 'react';
import { useNavigate } from 'react-router';
import { Button, Result } from 'antd';

const NotFoundComponent = () => {
    const navigate = useNavigate();
    return (
        <Result
            status='404'
            title='Page not found'
            subTitle='Sorry, the page you visited does not exist.'
            extra={
                <Button onClick={() => navigate('/')} type='primary'>
                    Back Home
                </Button>
            }
        />
    );
};

export default NotFoundComponent;
